import type {HostMap} from '../../../types'

export const TESTING = {
  account: 'delivery-frontend-account.taxi.tst.yandex.net',
  auth: 'delivery-frontend-auth.taxi.tst.yandex.net',
  order: 'delivery-frontend-order.taxi.tst.yandex.net',
  route: 'delivery-frontend-route.taxi.tst.yandex.net',
  tariffs: 'delivery-frontend-tariffs-lb.taxi.tst.yandex.net',
  yaAuthProxy: {
    default: 'ya-authproxy.taxi.tst.yandex.net',
    authorized: 'ya-authproxy.taxi.tst.yandex.ru',
  },
  avatars: 'avatars.mdst.yandex.net',
  passport: {
    default: 'passport-test.yandex.ru',
    id: 'id-test.yandex.ru',
    api: 'api.passport-test.yandex.ru',
  },
} as const satisfies HostMap
